import CardCommon from '@op/components/CardCommon';
import { tableIcon, lineIcon, barIcon } from '@op/constants/chart';
import React, { useState } from 'react';
import { useIntl } from 'umi';
import GoogleTrendsCharts from './GoogleTrendsCharts';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { SortBy } from 'tea-component/lib/table/addons';
import './index.scss';

export default function GoogleTrends({
  filter,
  gameData,
  wholeGameInfo,
}: {
  filter: any;
  gameData: any;
  wholeGameInfo: any;
}) {
  const { formatMessage } = useIntl();
  const [chartType, setChartType] = useState('line');
  const [sortBy, setSortBy] = useState<SortBy<any>>({
    by: 'time',
    order: 'desc',
  });
  const { downloadLegacy, downloading } = useDownloadParams();
  return (
    <CardCommon
      className="dbo-google-trends-card scroll-margin-top-target"
      id="Google Trends"
      title={formatMessage({ id: 'Google Trends' })}
      operations={[tableIcon, lineIcon, barIcon]}
      hasDownload
      downloadLoading={downloading}
      defaultOperation={chartType}
      handleOperationsOnClick={(item) => {
        setChartType(item?.symbol || 'line');
      }}
      handleDownloadOnClick={() => {
        const downloadLimit = 10000;
        const downLoadParams = {
          ...filter,
          stats_types: ['google_trends'],
          tab_type: 'google_trends',
          sort: sortBy,
          gameData,
        };
        const gameName = wholeGameInfo?.entity_name || '';
        const fileName = `${gameName} Compare Key Metrics - DataBrain Opinions`;
        downloadLegacy({
          limit: downloadLimit,
          fileName,
          params: downLoadParams,
          downloadFunc: 'getCompareKeyMetrics',
          sheetName: `Google Trends`,
        });
      }}
      logBtnId="Google Trends"
    >
      <GoogleTrendsCharts
        filter={filter}
        gameData={gameData}
        chartType={chartType}
        setSortBy={setSortBy}
        sortBy={sortBy}
      />
    </CardCommon>
  );
}
